import React, { useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import DirectoryContext from './state/context'
import { categories } from './colors'
import Legend from './Legend'

const Map = styled.div`
  padding: 0 5.8%;

  @media screen and (min-width: 960px) {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-self: flex-start;
    padding-right: 0;
    min-height: 100vh;
  }

  > div:first-child {
    position: relative;
    flex: 1 1 auto;

    > div {
      height: 460px !important;

      @media screen and (min-width: 960px) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100% !important;
      }
    }

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 168px;
      height: 40px;
      max-width: calc(100% - 32px);
      background-color: rgba(255, 255, 255, 0.85);
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      margin: 0;
      font-family: 'freight-text-pro', serif;
      font-size: 31px;
      font-size: 1.9375rem;
      font-weight: 700;
      color: #111;
      font-variant: lining-nums;

      @media screen and (min-width: 1200px) {
        width: 405px;
      }

      span {
        display: block;
        margin-left: 6px;
        font-family: 'freight-sans-condensed-pro', sans-serif;
        font-size: 20px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }

  button {
    min-width: 0;
    min-height: 0;
    border-radius: 0;
    margin-right: 0;
  }

  .marker {
    background-color: black;
    width: 19px;
    height: 19px;
    border-radius: 50%;
  }

  button.mapboxgl-ctrl-compass {
    display: none;
  }
`

const DirectoryMap = (props) => {
  const context = useContext(DirectoryContext)
  const [loadedMap, setLoadedMap] = useState(null)
  const [markers, setMarkers] = useState([])
  const mapContainer = useRef(null)
  const legendContainer = useRef(null)
  const { type } = props

  useEffect(() => {
    mapboxgl.accessToken =
      'pk.eyJ1IjoicmFkd29ya3NoZXJlIiwiYSI6ImNrZWtkNzBtYTA2NXkyeG1zNjdrOXR0dXAifQ.Ys9u81WQB_bWH69c6SCveA'

    if (mapContainer.current) {
      const mapInit = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/radworkshere/ckelmfs7i05m719po22avytxw',
        center: [-79.962, 40.4504],
        zoom: 10,
        attributionControl: false,
      })

      // Add zoom and rotation controls to the map.
      mapInit.addControl(new mapboxgl.NavigationControl(), 'bottom-right')

      // disable map zoom when using scroll
      mapInit.scrollZoom.disable()

      setLoadedMap(mapInit)
    }
  }, [context.showMap])

  useEffect(() => {
    if (loadedMap) {
      markers.forEach((marker) => {
        marker.remove()
      })

      setMarkers([])

      const newMarkers = []
      context.assets.forEach((asset) => {
        const el = document.createElement('div')
        el.className = `marker`
        el.dataset.asset = asset.id
        el.style.backgroundColor =
          categories[asset.category || 'Municipal Support']

        el.addEventListener('click', (event) => {
          const targetId = `#asset-${event.target.dataset.asset}`
          const target = document.querySelector(targetId)
          const parent = target.parentNode

          const y = target.offsetTop - parent.offsetTop

          parent.scrollTo({
            top: y,
            behavior: 'smooth',
          })
        })

        const newMarker = new mapboxgl.Marker(el)
          .setLngLat([asset.longitude, asset.latitude])
          .addTo(loadedMap)

        newMarkers.push(newMarker)
      })

      setMarkers(newMarkers)
    }
  }, [loadedMap, context.assets])

  return (
    <>
      {context.showMap && (
        <Map>
          <div>
            <div
              ref={mapContainer}
              style={{
                height: `calc(100vh - (88px + ${
                  (legendContainer || {}).current
                    ? legendContainer.current.offsetHeight + 'px'
                    : 0
                }))`,
              }}
            />

            <p>
              {context.assets.length}{' '}
              <span>
                Result
                {context.assets.length === 1 ? '' : 's'}
              </span>
            </p>
          </div>

          {type === 'assets' && <Legend ref={legendContainer} />}
        </Map>
      )}
    </>
  )
}

export default DirectoryMap
